module.exports = __webpack_public_path__ + "img/Billionaire-2.05a61874.png";